import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapState({ organization: ({ auth: { user } }) => user.organization }),
    ...mapGetters({ events: 'templates/events' }),
    eventOptions () {
      return this.events.map(element => ({
        text: this.setEvent(element.name),
        ...element
      }))
    }
  },
  methods: {
    ...mapActions({ getEvents: 'templates/getEvents' }),
    setMergeTag (variable = '') {
      switch (variable.toLowerCase()) {
        // case 'first_name':
        //   return this.$t('people.firstname')
        // case 'last_name':
        //   return this.$t('people.lastname')
        // case 'amount':
        //   return this.$t('common.amount')
        // case 'country':
        //   return this.$t('people.country')
        // case 'email':
        //   return this.$t('people.email')
        // case 'campaign':
        //   return this.$t('email_triggers.fields.campaign')
        // case 'project_name':
        //   return this.$t('email_triggers.fields.project_name')
        // case 'url_token':
        //   return 'URL Token'
        // case 'url':
        //   return 'URL'
        // case 'error':
        //   return 'ERROR'
        default:
          return variable.toLowerCase()
      }
    },
    setEvent (event = '') {
      switch (event.toLowerCase()) {
        case 'donation':
          return this.$t('templates.events.donation')
        case 'donationfail':
          return this.$t('templates.events.donation_fail')
        case 'lead':
          return this.$t('templates.events.lead')
        case 'leadfail':
          return this.$t('templates.events.lead_fail')
        case 'subscription':
          return this.$t('templates.events.subscription')
        case 'subscriptionfail':
          return this.$t('templates.events.subscription_fail')
        case 'donationcertificate':
          return this.$t('templates.events.donation_certificate')
        case 'donation_certificate_annulled':
          return this.$t('templates.events.donation_certificate_annulled')
        case 'petitionconfirmation':
          return this.$t('templates.events.petition_confirmation')
        case 'petitionaccepted':
          return this.$t('templates.events.petition_accepted')
        case 'petitionsignup':
          return this.$t('templates.events.petition_signup')
        case 'petitionrecoverpassword':
          return this.$t('templates.events.petition_recover_password')
        case 'petitiontarget':
          return this.$t('templates.events.petition_target')
        case 'landing':
          return 'Landing'
        case 'thankyoupage':
          return 'Página de agradecimiento'
        default:
          return event.toLowerCase()
      }
    },
    setEmailStatus (status = '') {
      switch (status.toLowerCase()) {
        case 'send':
          return {
            text: this.$t('email_triggers.status_options.send'),
            color: 'green darken-4',
            textColor: 'green--text text--darken-4'
          }
        case 'delivery':
          return {
            text: this.$t('email_triggers.status_options.delivery'),
            color: 'green darken-2',
            textColor: 'green--text text--darken-2'
          }
        case 'open':
          return {
            text: this.$t('email_triggers.status_options.open'),
            color: 'green',
            textColor: 'green--text'
          }
        case 'click':
          return {
            text: this.$t('email_triggers.status_options.click'),
            color: 'light-green',
            textColor: 'light-green--text'
          }
        case 'bounce':
          return {
            text: this.$t('email_triggers.status_options.bounce'),
            color: 'amber',
            textColor: 'amber--text'
          }
        case 'complaint':
          return {
            text: this.$t('email_triggers.status_options.complaint'),
            color: 'red',
            textColor: 'red--text'
          }
        case 'reject':
          return {
            text: this.$t('email_triggers.status_options.reject'),
            color: 'red darkend-2',
            textColor: 'red--text text--darkend-2'
          }
        case 'renderingfailure':
          return {
            text: this.$t('email_triggers.status_options.rendering_failure'),
            color: 'red darkend-4',
            textColor: 'red--text text--darkend-4'
          }
        case 'error':
          return {
            text: 'ERROR',
            color: 'red darkend-2',
            textColor: 'red--text text--darkend-2'
          }
        default:
          return {
            text: status.toLowerCase(),
            color: 'grey',
            textColor: 'grey--text'
          }
      }
    }
  }
}
